import { createSelector } from 'reselect';
import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericPost } from '@/_shared/types';
import { GenericApiError } from '@/_shared/types/apiError';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_DELETE_CHECK_PATH_KEY } from '@/swagger/constants/anagraphics-keys';
import { API_POST_EMPLOYEES_DELETE_CHECK, KEY_POST_EMPLOYEES_DELETE_CHECK } from '../constants';
import { MOCK_RESPONSE_POST_EMPLOYEES_DELETE_CHECK } from '../mocks';

type RequestPostEmployeesDeleteCheck = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_DELETE_CHECK_PATH_KEY
>['request']['body'];

type ResponsePostEmployeesDeleteCheck = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_DELETE_CHECK_PATH_KEY
>['response']['body'];

export type CallParamsPostEmployeesDeleteCheck = RequestPostEmployeesDeleteCheck & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

type CallResponsePostEmployeesDeleteCheck = ResponsePostEmployeesDeleteCheck;

type CallErrorPostEmployeesDeleteCheck = GenericApiError;

type CallSelectorsPostEmployeesDeleteCheck = {
  deleteCheckResponse?: CallResponsePostEmployeesDeleteCheck;
};

export const postEmployeesDeleteCheckCall = createGeneralCall<
  CallParamsPostEmployeesDeleteCheck,
  CallResponsePostEmployeesDeleteCheck,
  CallErrorPostEmployeesDeleteCheck,
  CallSelectorsPostEmployeesDeleteCheck
>({
  id: KEY_POST_EMPLOYEES_DELETE_CHECK,
  url: () => state => {
    const org = getCurrentOrganization(state);
    return API_POST_EMPLOYEES_DELETE_CHECK(org as unknown as string);
  },
  paramsSelector:
    ({ payload }) =>
    () => {
      return {
        employeeIds: payload.employeeIds,
      };
    },
  method: 'post',
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_POST_EMPLOYEES_DELETE_CHECK : undefined,
  selectors: {
    deleteCheckResponse: ({ selectors }) =>
      createSelector(
        selectors.response,
        res => (res as CallResponsePostEmployeesDeleteCheck) || undefined,
      ),
  },
});
